module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section01_02_beach-photo-d1fb88949966da81ba824c4bf8d8e2d6.jpg";